import { render, staticRenderFns } from "./ShowColorGrid.vue?vue&type=template&id=d730201e&scoped=true"
import script from "./ShowColorGrid.vue?vue&type=script&lang=js"
export * from "./ShowColorGrid.vue?vue&type=script&lang=js"
import style0 from "./ShowColorGrid.vue?vue&type=style&index=0&id=d730201e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d730201e",
  null
  
)

export default component.exports